import React from 'react';
import { CurricularClass11A2023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass11A2023 />;
};

export default ExtraCurricularActivitiesPage;